import { Location } from '@angular/common';
import { Component, DoCheck, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'app/lib/api.service';
import { SeriesService } from 'app/lib/series.service';
import { StorageService } from 'app/lib/storage.service';
import { voice } from 'app/models/course';

@Component({
    selector: 'app-series-voices-stories',
    templateUrl: './series-voices-stories.component.html',
    styleUrls: ['./series-voices-stories.component.scss'],
    standalone: false
})
export class SeriesVoicesStoriesComponent implements OnInit, DoCheck {
    storiesList: voice[] = [];
    loaded: boolean = false;
    lang: any = 'en';
    categoryList = [];
    categorySelected: number = 0;
    filteredStoryList: voice[] = [];
    isOpen = false;
    constructor(
        private api: ApiService,
        private storage: StorageService,
        private router: Router,
        private location: Location,
        private seriesService: SeriesService,
        private translate: TranslateService
    ) {this.categorySelected = 0;}
    // selected = 'option2';

    ngOnInit(): void {
        this.getCategories();
        this.getStories();
        this.lang = this.translate.currentLang;
    }
    ngDoCheck() {
        this.lang = this.translate.currentLang;
    }
    getCategories() {
        this.seriesService.categories.subscribe(data => {
            this.categoryList = data;
        });
        this.seriesService.getCategories();
    }
    getStories() {
        this.seriesService.voiceStorySeries.subscribe((data: any) => {
            if (!data || data.status == 'error') return;
            if (data.status == 'success') {
                this.setVoiceSeries(data.seriesList);
            }
        });
        this.seriesService.getVoiceStorySeries();
    }
    selectedOption: string = '';
    setVoiceSeries(series: any) {
        if (!Object.keys(series).length) {
            return;
        } else {
            this.loaded = true;
            this.storiesList = voice.initializeArray(series, 'stories');
            this.getFilteredList();
        }
    }
    getFilteredList() {
        if (this.categorySelected !== 0) {
            this.filteredStoryList = this.storiesList.filter(
                item => item.category === this.categorySelected
            );
        } else {
            this.filteredStoryList = [...this.storiesList];
        }
    }
    goToVoiceStory(story) {
        this.router.navigate([
            '/app/series/voices/' + story.seriesType + '/' + story.id,
        ]).then(() => {
            this.resetScroll();
        });
    }

    resetScroll() {
        // Immediately reset window scroll
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        
        // Try multiple times with increasing delays to ensure scroll resets
        [0, 50, 100, 150].forEach(delay => {
            setTimeout(() => {
                window.scrollTo(0, 0);
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                
                const detailsSection = document.querySelector('.details-top-section');
                if (detailsSection) {
                    detailsSection.scrollTop = 0;
                }

                const appPage = document.querySelector('.app-l-page');
                if (appPage) {
                    appPage.scrollTop = 0;
                }
                
                const main = document.querySelector('main');
                if (main) {
                    main.scrollTop = 0;
                }
            }, delay);
        });
    }

    goBack() {
        this.location.back();
    }
}
